// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { AiOutlineFrown } from 'react-icons/ai';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
// import { CartContext } from '../Cart/CartContext'; // ✅ Import CartContext
// import { WishlistContext } from '../Wishlist/WishlistContext'; // (Optional) if using wishlist
// import { FaRegBookmark } from 'react-icons/fa';

// const FilteredProductsCuisines = () => {

//     const { superCatName, subCatName, filterType,extraParam  } = useParams();

//     console.log( 'this is cat and sub_cat ',superCatName, subCatName)

//     console.log('this is filterType', filterType)
//      console.log('this is extraParam', extraParam)

//     const navigate = useNavigate();

//     const { cartItems, addToCart, removeFromCart } = useContext(CartContext); // ✅ Use Cart Context
//     const { addToWishlist } = useContext(WishlistContext); // ✅ (Optional) Use Wishlist Context

//     const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [selectedVariants, setSelectedVariants] = useState({});
//     const [variantDropdownOpen, setVariantDropdownOpen] = useState({});
//     const [quantities, setQuantities] = useState({});

//     const decodedSuperCat = decodeURIComponent(superCatName || '');
//     const decodedSubCat = decodeURIComponent(subCatName || '');

//     useEffect(() => {
//         const fetchProducts = async () => {
//             try {
//                 const res = await axios.get('https://api.glocart.in/pages/api/products/get');
//                 const allProducts = res.data;

//                 const filtered = allProducts.filter(prod => {
//                     const matchesCategory = decodedSuperCat
//                         ? prod.category?.toLowerCase() === decodedSuperCat.toLowerCase()
//                         : true;
//                     const matchesSubCategory = decodedSubCat
//                         ? prod.sub_category?.toLowerCase() === decodedSubCat.toLowerCase()
//                         : true;

//                     console.log('this is matchescategory',matchesCategory)

//                     return matchesCategory && matchesSubCategory;
//                 });


//                 const defaultsVar = {};
//                 const defaultsQty = {};

//                 filtered.forEach(prod => {
//                     const cartItem = cartItems.find(ci => ci.productId === prod.id);
//                     if (cartItem) {
//                         const matchedVariant = prod.variants.find(v => v.id === cartItem.variantId);
//                         defaultsVar[prod.id] = matchedVariant || prod.variants[0];
//                         defaultsQty[prod.id] = cartItem.quantity;
//                     } else {
//                         defaultsVar[prod.id] = prod.variants[0];
//                         defaultsQty[prod.id] = 0;
//                     }
//                 });
//                 console.log('this is filtered',filtered)

//                 setProducts(filtered);
//                 setSelectedVariants(defaultsVar);
//                 setQuantities(defaultsQty);
//                 setLoading(false);
//             } catch (err) {
//                 console.error('Error fetching products:', err);
//                 setLoading(false);
//             }
//         };

//         fetchProducts();
//     }, [filterType, cartItems]);

//     const handleToggleDropdown = (productId) => {
//         setVariantDropdownOpen(prev => ({
//             ...prev,
//             [productId]: !prev[productId]
//         }));
//     };

//     const handleSelectVariant = (productId, variant) => {
//         setSelectedVariants(prev => ({
//             ...prev,
//             [productId]: variant
//         }));
//         setVariantDropdownOpen(prev => ({
//             ...prev,
//             [productId]: false
//         }));

//         const cartItem = cartItems.find(ci => ci.productId === productId && ci.variantId === variant.id);
//         setQuantities(prev => ({
//             ...prev,
//             [productId]: cartItem ? cartItem.quantity : 0
//         }));
//     };

//     const computeFinalPrice = (variant) => {
//         if (!variant) return 0;
//         if (variant.discount && variant.discount > 0) {
//             return Math.round(variant.price - (variant.price * variant.discount) / 100);
//         }
//         return variant.price;
//     };

//     return (
//         <>
//             <Header />

//             <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
//                 <h4 style={{ textTransform: 'uppercase', marginBottom: '20px' }}>
//                     {superCatName ? superCatName.replace('-', ' ') : 'All Products'}

//                     {subCatName ? ` / ${subCatName.replace('-', ' ')}` : ''}
//                 </h4>
//                 <hr></hr>
//                 {loading ? (
//                     <p>Loading products...</p>
//                 ) : products.length === 0 ? (
//                     <div className="text-center mt-5" style={{ padding: '40px 20px' }}>
//                         <AiOutlineFrown size={80} color="#0057A0" />
//                         <h4 className="mt-4 text-muted" style={{ fontWeight: 'bold' }}>
//                             No products found for "<span style={{ color: '#0057A0' }}>{filterType?.replace('-', ' ')}</span>"
//                         </h4>
//                         <p className="text-secondary" style={{ marginTop: 10 }}>
//                             Try exploring other categories or filters.
//                         </p>

//                         <button
//                             onClick={() => navigate('/')}
//                             style={{
//                                 marginTop: 20,
//                                 backgroundColor: '#0057A0',
//                                 color: '#fff',
//                                 border: 'none',
//                                 padding: '10px 24px',
//                                 borderRadius: '6px',
//                                 fontSize: '16px',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.3s ease'
//                             }}
//                             onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b71c1c'}
//                             onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0057A0'}
//                         >
//                             🛒 Shop Now
//                         </button>
//                     </div>

//                 ) : (
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20, }}>
//                         {products.map(p => {
//                             const variant = selectedVariants[p.id];
//                             const qty = quantities[p.id] || 0;
//                             const finalPrice = computeFinalPrice(variant);
//                             const hasDiscount = variant?.discount > 0;

//                             return (
//                                 <div key={p.id} style={{ border: '1px solid #e0e0e0', background: '#fff', borderRadius: '10px', position: 'relative' }}>
//                                     {hasDiscount && (
//                                         <div style={{ position: 'absolute', top: 8, left: 8, background: '#4caf50', color: '#fff', padding: '2px 6px', fontSize: 12, borderRadius: '10px' }}>
//                                             {variant.discount}% OFF
//                                         </div>
//                                     )}

//                                     <div style={{ margin: '16px', border: '1px solid #eee', borderRadius: '10px', backgroundColor: '#fafafa', padding: 8 }}>
//                                         <div onClick={() => navigate(`/product/${p.id}`)} style={{ cursor: 'pointer' }}>
//                                             <img src={p.image_1} alt={p.name} style={{ width: '100%', height: 180, objectFit: 'contain' }} />
//                                         </div>
//                                     </div>

//                                     <div style={{ padding: 10 }}>
//                                         <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>
//                                             ⚡ {p.category}
//                                         </p>
//                                         <p style={{ fontSize: 13, margin: 0 }}>{p.brand}</p>
//                                         <h4 style={{ fontSize: 14, margin: '4px 0 8px' }}>{p.name}</h4>

//                                         {/* Variant Dropdown */}
//                                         <div style={{ position: 'relative', marginBottom: 10 }}>
//                                             <div
//                                                 style={{
//                                                     border: '1px solid #ccc',
//                                                     padding: '6px 8px',
//                                                     backgroundColor: '#fff',
//                                                     cursor: 'pointer',
//                                                     fontSize: '13px'
//                                                 }}
//                                                 onClick={() => handleToggleDropdown(p.id)}
//                                             >
//                                                 <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                                     <span style={{ fontWeight: 'bold' }}>₹{finalPrice}</span>
//                                                     {hasDiscount && (
//                                                         <>
//                                                             <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>
//                                                             <span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                             </div>

//                                             {variantDropdownOpen[p.id] && (
//                                                 <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: 4, maxHeight: 200, overflowY: 'auto' }}>
//                                                     {p.variants.map(v => {
//                                                         const vFinal = computeFinalPrice(v);
//                                                         return (
//                                                             <div key={v.id} onClick={() => handleSelectVariant(p.id, v)} style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: variant?.id === v.id ? '#f6f6f6' : '#fff', cursor: 'pointer', fontSize: '13px' }}>
//                                                                 <div>
//                                                                     <strong>{v.unit_value} {v.unit}</strong>{' '}
//                                                                     {v.discount > 0 && (
//                                                                         <span style={{ color: 'green', fontWeight: 'bold' }}>{v.discount}% OFF</span>
//                                                                     )}
//                                                                 </div>
//                                                                 <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
//                                                                     <span style={{ fontWeight: 'bold' }}>₹{vFinal}</span>
//                                                                     {v.discount > 0 && (
//                                                                         <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{v.price}</span>
//                                                                     )}
//                                                                     <span style={{ fontSize: 11, backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>
//                                                                         ⚡ Select
//                                                                     </span>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <div style={{ fontSize: 15, fontWeight: 'bold' }}>
//                                             ₹{finalPrice}
//                                             {hasDiscount && (
//                                                 <span style={{ fontSize: 13, color: '#999', textDecoration: 'line-through', marginLeft: 6 }}>
//                                                     ₹{variant.price}
//                                                 </span>
//                                             )}
//                                         </div>

//                                         {/* Add to Cart Controls */}
//                                         <div className='mt-5' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
//                                             <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }} onClick={() => { addToWishlist(p, variant); alert(`${p.name} saved to wishlist!`); }}>
//                                                 <FaRegBookmark />
//                                             </button>


//                                             {qty > 0 ? (
//                                                 <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
//                                                     <button
//                                                         onClick={() => {
//                                                             const newQty = qty - 1;
//                                                             if (newQty <= 0) {
//                                                                 setQuantities(prev => ({ ...prev, [p.id]: 0 }));
//                                                                 removeFromCart(p.id, variant.id);
//                                                             } else {
//                                                                 setQuantities(prev => ({ ...prev, [p.id]: newQty }));
//                                                                 addToCart({
//                                                                     productId: p.id,
//                                                                     variantId: variant.id,
//                                                                     name: p.name,
//                                                                     image: p.image_1,
//                                                                     price: finalPrice
//                                                                 }, -1);
//                                                             }
//                                                         }}
//                                                         style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
//                                                     >−</button>
//                                                     <div style={{ padding: '6px 12px', fontSize: 14 }}>{qty}</div>
//                                                     <button
//                                                         onClick={() => {
//                                                             const newQty = qty + 1;
//                                                             setQuantities(prev => ({ ...prev, [p.id]: newQty }));
//                                                             addToCart({
//                                                                 productId: p.id,
//                                                                 variantId: variant.id,
//                                                                 name: p.name,
//                                                                 image: p.image_1,
//                                                                 price: finalPrice
//                                                             }, 1);
//                                                         }}
//                                                         style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
//                                                     >+</button>
//                                                 </div>
//                                             ) : (
//                                                 <button
//                                                     onClick={() => {
//                                                         setQuantities(prev => ({ ...prev, [p.id]: 1 }));
//                                                         addToCart({
//                                                             productId: p.id,
//                                                             variantId: variant.id,
//                                                             name: p.name,
//                                                             image: p.image_1,
//                                                             price: finalPrice
//                                                         }, 1);
//                                                     }}
//                                                     style={{ padding: '6px 90px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }}
//                                                 >
//                                                     Add
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 )}
//             </div>
//             <Footer />
//         </>
//     );
// };

// export default FilteredProductsCuisines;



import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { AiOutlineFrown } from 'react-icons/ai';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { CartContext } from '../Cart/CartContext'; // ✅ Import CartContext
import { WishlistContext } from '../Wishlist/WishlistContext'; // (Optional) if using wishlist
import { FaRegBookmark } from 'react-icons/fa';

import ReactCountryFlag from "react-country-flag";
import { countryCodeMap } from "../countryMap/countryMap";

import { FcBookmark } from "react-icons/fc";

const FilteredProductsCuisines = () => {

    // const { superCatName:extraParam , subCatName, filterType } = useParams();

    // console.log(superCatName, subCatName)
    const { extraParam, filterType } = useParams();
    const navigate = useNavigate();

    const { cartItems, addToCart, removeFromCart } = useContext(CartContext); // ✅ Use Cart Context
    const { addToWishlist } = useContext(WishlistContext); // ✅ (Optional) Use Wishlist Context

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedVariants, setSelectedVariants] = useState({});
    const [variantDropdownOpen, setVariantDropdownOpen] = useState({});
    const [quantities, setQuantities] = useState({});

    const decodedSuperCat = decodeURIComponent(extraParam || '');
    // const decodedSubCat = decodeURIComponent(subCatName || '');

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await axios.get('https://api.glocart.in/pages/api/products/get');
                const allProducts = res.data;

                // const filtered = allProducts.filter(prod => {
                //     const matchesCategory = decodedSuperCat
                //         ? prod.category?.toLowerCase() === decodedSuperCat.toLowerCase()
                //         : true;
                //     const matchesSubCategory = decodedSubCat
                //         ? prod.sub_category?.toLowerCase() === decodedSubCat.toLowerCase()
                //         : true;

                //         console.log(matchesCategory)

                //     return matchesCategory && matchesSubCategory;
                // });
                const filtered = allProducts.filter(prod => {
                    return decodedSuperCat
                        ? prod.super_category?.toLowerCase() === decodedSuperCat.toLowerCase()
                        : true;
                });



                const defaultsVar = {};
                const defaultsQty = {};

                filtered.forEach(prod => {
                    const cartItem = cartItems.find(ci => ci.productId === prod.id);
                    if (cartItem) {
                        const matchedVariant = prod.variants.find(v => v.id === cartItem.variantId);
                        defaultsVar[prod.id] = matchedVariant || prod.variants[0];
                        defaultsQty[prod.id] = cartItem.quantity;
                    } else {
                        defaultsVar[prod.id] = prod.variants[0];
                        defaultsQty[prod.id] = 0;
                    }
                });

                setProducts(filtered);
                setSelectedVariants(defaultsVar);
                setQuantities(defaultsQty);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching products:', err);
                setLoading(false);
            }
        };

        fetchProducts();
    }, [filterType, cartItems]);

    const handleToggleDropdown = (productId) => {
        setVariantDropdownOpen(prev => ({
            ...prev,
            [productId]: !prev[productId]
        }));
    };

    const handleSelectVariant = (productId, variant) => {
        setSelectedVariants(prev => ({
            ...prev,
            [productId]: variant
        }));
        setVariantDropdownOpen(prev => ({
            ...prev,
            [productId]: false
        }));

        const cartItem = cartItems.find(ci => ci.productId === productId && ci.variantId === variant.id);
        setQuantities(prev => ({
            ...prev,
            [productId]: cartItem ? cartItem.quantity : 0
        }));
    };

    const computeFinalPrice = (variant) => {
        if (!variant) return 0;
        if (variant.discount && variant.discount > 0) {
            return Math.round(variant.price - (variant.price * variant.discount) / 100);
        }
        return variant.price;
    };

    const [wishlist, setWishlist] = useState({}); // mapping key -> true

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;

        const fetchWishlist = () => {
            axios
                .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
                .then((res) => {
                    const wishMap = {};
                    res.data.forEach((item) => {
                        const key = `${item.productId}_${item.variantId}`;
                        wishMap[key] = true;
                    });
                    setWishlist(wishMap);
                })
                .catch((err) => console.error('Error fetching wishlist:', err));
        };

        // Initial fetch
        fetchWishlist();

        // Fetch every 1 second
        const intervalId = setInterval(fetchWishlist, 1000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, []);


    return (
        <>
            <Header />

            <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
                <h4 style={{ textTransform: 'uppercase', marginBottom: '20px' }}>
                    {extraParam ? extraParam.replace('-', ' ') : 'All Products'}
                    {/* {subCatName ? ` / ${subCatName.replace('-', ' ')}` : ''} */}

                </h4>
                <hr></hr>
                {loading ? (
                    <p>Loading products...</p>
                ) : products.length === 0 ? (
                    <div className="text-center mt-5" style={{ padding: '40px 20px' }}>
                        <AiOutlineFrown size={80} color="#0057A0" />
                        <h4 className="mt-4 text-muted" style={{ fontWeight: 'bold' }}>
                            No products found for "<span style={{ color: '#0057A0' }}>{filterType?.replace('-', ' ')}</span>"
                        </h4>
                        <p className="text-secondary" style={{ marginTop: 10 }}>
                            Try exploring other categories or filters.
                        </p>

                        <button
                            onClick={() => navigate('/')}
                            style={{
                                marginTop: 20,
                                backgroundColor: '#0057A0',
                                color: '#fff',
                                border: 'none',
                                padding: '10px 24px',
                                borderRadius: '6px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b71c1c'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0057A0'}
                        >
                            🛒 Shop Now
                        </button>
                    </div>

                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20, }}>
                        {products.map(p => {
                            const variant = selectedVariants[p.id];
                            const qty = quantities[p.id] || 0;
                            const finalPrice = computeFinalPrice(variant);
                            const hasDiscount = variant?.discount > 0;
                            const key = `${p.id}_${variant?.id}`;
                            const isWishlisted = wishlist[key];
                            return (
                                <div key={p.id} style={{ border: '1px solid #e0e0e0', background: '#fff', borderRadius: '10px', position: 'relative' }}>
                                    {hasDiscount && (
                                        <div style={{
                                            position: 'absolute', top: 8, left: 8, background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)",
                                            color: '#0058A2',
                                            fontWeight: 'bold', padding: '2px 6px', fontSize: 12, borderRadius: '10px'
                                        }}>
                                            {variant.discount}% OFF
                                        </div>
                                    )}

                                    <div style={{ margin: '16px', border: '1px solid #eee', borderRadius: '10px', backgroundColor: '#fafafa', padding: 8 }}>
                                        <div onClick={() => navigate(`/product/${p.id}`)} style={{ cursor: 'pointer' }}>
                                            <img src={p.image_1} alt={p.name} style={{ width: '100%', height: 180, objectFit: 'contain' }} />
                                        </div>
                                    </div>

                                    <div style={{ padding: 10 }}>

                                        <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <ReactCountryFlag
                                                countryCode={countryCodeMap[p.super_category]}
                                                svg
                                                style={{ width: '18px', height: '18px' }}
                                            />
                                            {p.super_category}
                                        </p>
                                        <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>
                                            ⚡ {p.category}
                                        </p>
                                        <p style={{ fontSize: 13, margin: 0 }}>{p.brand}</p>
                                        <h4 style={{ fontSize: 14, margin: '4px 0 8px' }}>{p.name}</h4>

                                        {/* Variant Dropdown */}
                                        <div style={{ position: 'relative', marginBottom: 10 }}>
                                            <div
                                                style={{
                                                    border: '1px solid #ccc',
                                                    padding: '6px 8px',
                                                    backgroundColor: '#fff',
                                                    cursor: 'pointer',
                                                    fontSize: '13px'
                                                }}
                                                onClick={() => handleToggleDropdown(p.id)}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <span style={{ fontWeight: 'bold' }}>₹{finalPrice}</span>
                                                    {hasDiscount && (
                                                        <>
                                                            <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>
                                                            <span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {variantDropdownOpen[p.id] && (
                                                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: 4, maxHeight: 200, overflowY: 'auto' }}>
                                                    {p.variants.map(v => {
                                                        const vFinal = computeFinalPrice(v);
                                                        return (
                                                            <div key={v.id} onClick={() => handleSelectVariant(p.id, v)} style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: variant?.id === v.id ? '#f6f6f6' : '#fff', cursor: 'pointer', fontSize: '13px' }}>
                                                                <div>
                                                                    <strong>{v.unit_value} {v.unit}</strong>{' '}
                                                                    {v.discount > 0 && (
                                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>{v.discount}% OFF</span>
                                                                    )}
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                                                                    <span style={{ fontWeight: 'bold' }}>₹{vFinal}</span>
                                                                    {v.discount > 0 && (
                                                                        <span style={{ textDecoration: 'line-through', color: '#999' }}>₹{v.price}</span>
                                                                    )}
                                                                    <span style={{ fontSize: 11, backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>
                                                                        ⚡ Select
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ fontSize: 15, fontWeight: 'bold' }}>
                                            ₹{finalPrice}
                                            {hasDiscount && (
                                                <span style={{ fontSize: 13, color: '#999', textDecoration: 'line-through', marginLeft: 6 }}>
                                                    ₹{variant.price}
                                                </span>
                                            )}
                                        </div>

                                        {/* Add to Cart Controls */}
                                        <div className='mt-5' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
                                            <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                onClick={() => {
                                                    addToWishlist(p, variant);

                                                    // alert(`${p.name} saved to wishlist!`); 
                                                    alert(
                                                        isWishlisted
                                                            ? `${p.name} removed from wishlist!`
                                                            : `${p.name} saved to wishlist!`
                                                    );
                                                }}>

                                                {/* <FaRegBookmark /> */}
                                                {isWishlisted ? (
                                                    <FcBookmark size={22} />     // filled icon
                                                ) : (
                                                    <FaRegBookmark size={22} />   // empty icon
                                                )}
                                            </button>


                                            {qty > 0 ? (
                                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                    <button
                                                        onClick={() => {
                                                            const newQty = qty - 1;
                                                            if (newQty <= 0) {
                                                                setQuantities(prev => ({ ...prev, [p.id]: 0 }));
                                                                removeFromCart(p.id, variant.id);
                                                            } else {
                                                                setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                                addToCart({
                                                                    productId: p.id,
                                                                    variantId: variant.id,
                                                                    name: p.name,
                                                                    image: p.image_1,
                                                                    price: finalPrice
                                                                }, -1);
                                                            }
                                                        }}
                                                        style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                    >−</button>
                                                    <div style={{ padding: '6px 12px', fontSize: 14 }}>{qty}</div>
                                                    <button
                                                        onClick={() => {
                                                            const newQty = qty + 1;
                                                            setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                            addToCart({
                                                                productId: p.id,
                                                                variantId: variant.id,
                                                                name: p.name,
                                                                image: p.image_1,
                                                                price: finalPrice
                                                            }, 1);
                                                        }}
                                                        style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                    >+</button>
                                                </div>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        setQuantities(prev => ({ ...prev, [p.id]: 1 }));
                                                        addToCart({
                                                            productId: p.id,
                                                            variantId: variant.id,
                                                            name: p.name,
                                                            image: p.image_1,
                                                            price: finalPrice
                                                        }, 1);
                                                    }}
                                                    style={{ padding: '6px 90px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }}
                                                >
                                                    Add
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default FilteredProductsCuisines;
